var _path, _circle;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBellOutlineOn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.3333 27.9998H18.6667C18.6667 29.4665 17.4667 30.6665 16 30.6665C14.5333 30.6665 13.3333 29.4665 13.3333 27.9998ZM28 25.3332V26.6665H4V25.3332L6.66667 22.6665V14.6665C6.66667 10.5332 9.33333 6.93317 13.3333 5.73317V5.33317C13.3333 3.8665 14.5333 2.6665 16 2.6665C17.4667 2.6665 18.6667 3.8665 18.6667 5.33317V5.73317C22.6667 6.93317 25.3333 10.5332 25.3333 14.6665V22.6665L28 25.3332ZM22.6667 14.6665C22.6667 10.9332 19.7333 7.99984 16 7.99984C12.2667 7.99984 9.33333 10.9332 9.33333 14.6665V23.9998H22.6667V14.6665Z",
    fill: "#131313"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 22.6667,
    cy: 10.6667,
    r: 6.66667,
    fill: "#FF0D3C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBellOutlineOn);
export default __webpack_public_path__ + "static/media/bell-outline-on.8cff72d19695dab4cb5fbb0cc503aa8c.svg";
export { ForwardRef as ReactComponent };